import {QuestionsAPI} from 'api/questions';
import {QuestionLinkList} from 'components/questions/question_link_list';
import {Button} from 'components/system/button';
import {ContentPlaceholder} from 'components/system/content_placeholder';
import {useEffect, useState} from 'react';
import styles from './recommended_questions.module.css';

export const RecommendedQuestions = ({
  questions: initialQuestions = noQuestions,
  collapsible = false,
  initialCollapsed = false,
  trackingComponent,
  plainList = false,
}: Props) => {
  const [questions, setQuestions] = useState<Question[]>(initialQuestions);
  const [loading, setLoading] = useState(initialQuestions.length === 0);
  const [collapsed, setCollapsed] = useState(initialCollapsed);

  useEffect(() => {
    // If no questions are provided externally then get recommended questions from the API.
    // If the user is logged in then these will be provided by the recommender based on their preferences.
    const getRecommendedQuestions = async () => {
      const questions = await QuestionsAPI.getQuestions(5);
      setQuestions(questions);
      setLoading(false);
    };
    if (questions.length === 0) {
      getRecommendedQuestions();
    }
  }, []);

  useEffect(() => {
    setQuestions(initialQuestions);
    if (initialCollapsed) setCollapsed(true);
  }, [initialQuestions]);

  return (
    <div className={styles.container}>
      {!plainList && (
        <>
          {' '}
          <div className={styles.title}>Recommended questions for you</div>
          <p>Personalized based on your user activity, skill level, and preferences.</p>
        </>
      )}
      {loading ? (
        <ContentPlaceholder />
      ) : (
        <>
          {!collapsed && (
            <QuestionLinkList questions={questions} trackingComponent={trackingComponent} />
          )}
          {collapsible && collapsed && (
            <Button size='sm' color='greyLight' onClick={() => setCollapsed(!collapsed)}>
              View recommended questions
            </Button>
          )}
        </>
      )}
    </div>
  );
};

type Props = {
  questions?: Question[];
  collapsible?: boolean;
  initialCollapsed?: boolean;
  trackingComponent: string;
  plainList?: boolean;
};

const noQuestions: Question[] = [];
